# adapted from https://github.com/jashkenas/coffee-script/wiki/FAQ
module.exports = (mixins..., classReference) ->
  for m in mixins
    for key, value of m::
      classReference::[key] = value
  classReference



// WEBPACK FOOTER //
// ./app/scripts/lib/mixin.coffee